import _ from 'lodash';
import React from 'react';

import DateRangePicker from 'components/DateRangePicker';

import ToggleSelectFilter from 'components/Filters/ToggleSelectFilter';

import './styles.css';

const ROOM_PURPOSES_TYPES = [
  {value: 'long_stay', label: 'Long stay'},
  {value: 'short_stay', label: 'Short stay'},
  {value: 'extended_stay', label: 'Extended stay'},
  {value: 'corporate', label: 'Corporate'},
  {value: 'guest', label: 'Guest'}
];

const BottomLeftFixedCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex,
  input
}: any) => {
  // Custom Overlay will be fixed to bottom right from input

  const position = input.parentElement.getBoundingClientRect();

  return (
    <div
      className="BottomLeftFixedCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}
      style={{right: 20, top: position.top + position.height}}>
      <div className="OverlayWrapper colab-small-border-radius">{children}</div>
    </div>
  );
};

interface RoomPurposeTypeWithDateRangeFilterProps {
  roomPurposeTypes: Array<string>;
  purposeStartDate: string | null;
  purposeEndDate: string | null;
  setFilter: any;
}

class RoomPurposeTypeWithDateRangeFilter extends React.Component<
  RoomPurposeTypeWithDateRangeFilterProps
> {
  onPurposeChange = (field, value) => {
    if (field == 'type') {
      if (value.length == 0) {
        this.props.setFilter('purposeStartDate', null, true);
        this.props.setFilter('purposeStartDate', null, true);
      }
      const withoutFetching =
        value && !this.props.purposeStartDate && !this.props.purposeEndDate;

      this.props.setFilter('roomPurposeTypes', value, withoutFetching);
    }
    if (field == 'startDate') {
      const withoutFetching = this.props.roomPurposeTypes.length == 0;

      this.props.setFilter('purposeStartDate', value, withoutFetching);
    }
    if (field == 'endDate') {
      const withoutFetching = this.props.roomPurposeTypes.length == 0;

      this.props.setFilter('purposeEndDate', value, withoutFetching);
    }
  };

  render() {
    return (
      <div className="RoomPurposeTypeWithDateRangeFilter">
        <ToggleSelectFilter
          label="Room Purpose Type"
          data={ROOM_PURPOSES_TYPES}
          value={this.props.roomPurposeTypes}
          onChange={value => this.onPurposeChange('type', value)}
        />
        {!_.isEmpty(this.props.roomPurposeTypes) && (
          <DateRangePicker
            className="colab-small-border-radius"
            overlayComponent={BottomLeftFixedCustomOverlay}
            start={this.props.purposeStartDate}
            end={this.props.purposeEndDate}
            handleChange={this.onPurposeChange}
          />
        )}
      </div>
    );
  }
}

export default RoomPurposeTypeWithDateRangeFilter;
